import { useMemo } from "react";

import { queryKeys } from "../queryKeys";
import { getOptionsContract, type OptionContract } from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOptionContractsBatch = ({
  symbols,
  options,
}: {
  symbols: string[];
  options?: QueryOptions<(OptionContract | undefined)[]>;
}) => {
  const sortedSymbols = useMemo(() => [...symbols].sort(), [symbols]);
  return useRequest(
    queryKeys.options.contractsBatch(sortedSymbols),
    () =>
      Promise.all(sortedSymbols.map((s) => getOptionsContract({ symbol: s }))),
    {
      ...options,
      enabled: (options?.enabled ?? true) && sortedSymbols.length > 0,
    },
  );
};

export default useGetOptionContractsBatch;
